import { Button, Checkbox, Dialog, DialogContent, FormControlLabel, TextField } from '@mui/material'
import React, { useState } from 'react'
import Swal from 'sweetalert2';
import api from '../../../api/api'
import { AGENT_CONFIG } from '../config';

export default function DocumentAddon({ open, setOpen, requestNo }) {
    const [typeFiles, setTypeFiles] = useState([{
        name: 'สำเนาบัตรประจำตัวประชาชน',
        value: 'IdCardFiles',
        selected: false
    },
    {
        name: 'สำเนาหนังสือจดทะเบียนนิติบุคคล',
        value: 'JuristicPersonFiles',
        selected: false
    },
    {
        name: 'สำเนาใบอนุญาตขายเมล็ดพันธุ์ควบคุม (พ.พ.4)',
        value: 'LicenseFiles',
        selected: false
    },
    {
        name: 'แผนผังแสดงที่อยู่สถานที่ตั้งของสถานที่จำหน่ายเมล็ดพันธุ์',
        value: 'StoreMapFiles',
        selected: false
    },
    {
        name: 'หนังสือมอบอำนาจซึ่งติดอากรแสตมป์ตามกฎหมาย',
        value: 'ProxyFiles',
        selected: false
    },
    {
        name: 'เอกสารอื่นๆ',
        value: 'OtherFiles',
        selected: false
    },
    ]);
    const [remark, setRemark] = useState('')
    const [approverName, setApproverName] = useState('')
    const [approverTel, setApproverTel] = useState('')
    const [approverNameError, setApproverNameError] = useState(false)
    const [approverTelError, setApproverTelError] = useState(false)

    // ExpireFile = [
    //     {
    //         name: 'สำเนาใบอนุญาตตัวแทนจำหน่ายเมล็ดพันธุ์พืช ของกรมข้าว ที่สิ้นอายุ',
    //         value: 'ExpiredAgentFiles',
    //         selected: false
    //     },

    //     {
    //         name: 'สำเนาใบอนุญาตรวบรวมเมล็ดพันธุ์ควบคุมเพื่อการค้า',
    //         value: 'LicenseFiles',
    //         selected: false
    //     },

    //     {
    //         name: 'หนังสือมอบอำนาจ ในกรณีที่ผู้ยื่นคำขอได้รับมอบอำนาจให้ยื่นคำขอต่ออายุแทน',
    //         value: 'ProxyFiles',
    //         selected: false
    //     },
    // ]
    const handleAdd = async () => {

        const typeSelected = typeFiles.filter(x => x.selected);
       
        if (typeSelected.length === 0 && !remark) {
            Swal.fire(
                'กรุณาเลือกเอกสารที่ต้องการขอเพิ่มเติม หรือ กรอกหมายเหตุ',
                '',
                'question'
            )
        } else {
            if(!approverName) {
               return setApproverNameError(true)
            }
            if(!approverTel) {
               return setApproverTelError(true)
            }
            const IdCard = typeFiles.find(x => x.value === 'IdCardFiles');
            const JuristicPerson = typeFiles.find(x => x.value === 'JuristicPersonFiles');
            const License = typeFiles.find(x => x.value === 'LicenseFiles');
            const StoreMap = typeFiles.find(x => x.value === 'StoreMapFiles');
            const Proxy = typeFiles.find(x => x.value === 'ProxyFiles');
            // const ExpiredAgent = this.typeFiles.find(x => x.value === 'IdCardFiles');
            const Other = typeFiles.find(x => x.value === 'OtherFiles');

            const body = {
                IdCard: IdCard.selected,
                IdCardRemark: IdCard.remark || '',
                JuristicPerson: JuristicPerson.selected,
                JuristicPersonRemark: JuristicPerson.remark || '',
                License: License.selected,
                LicenseRemark: License.remark || '',
                StoreMap: StoreMap.selected,
                StoreMapRemark: StoreMap.remark || '',
                Proxy: Proxy.selected,
                ProxyRemark: Proxy.remark || '',
                ExpiredAgent: false,
                Other: Other.selected,
                OtherRemark: Other.remark || '',
                Remark: remark || undefined,
                ApproverName: approverName,
                ApproverTel: approverTel
            }
            const url = AGENT_CONFIG.requests.getAgents.url + `/${requestNo}/request-doc`;
            const res = await api.put(url, body)
            // this.loading.submit = false;
            if (res) {
                Swal.fire('ส่งเอกสารสำเร็จ','','success')
                setOpen(false)
                setApproverName('')
                setApproverTel('')
                setRemark('')
                setApproverNameError(false)
                setApproverTelError(false)
                setTypeFiles([
                    {
                        name: 'สำเนาบัตรประจำตัวประชาชน',
                        value: 'IdCardFiles',
                        selected: false
                    },
                    {
                        name: 'สำเนาหนังสือจดทะเบียนนิติบุคคล',
                        value: 'JuristicPersonFiles',
                        selected: false
                    },
                    {
                        name: 'สำเนาใบอนุญาตขขายเมล็ดพันธุ์ควบคุม (พ.พ.4)',
                        value: 'LicenseFiles',
                        selected: false
                    },
                    {
                        name: 'แผนผังแสดงที่อยู่สถานที่ตั้งของสถานที่จำหน่ายเมล็ดพันธุ์',
                        value: 'StoreMapFiles',
                        selected: false
                    },
                    {
                        name: 'หนังสือมอบอำนาจซึ่งติดอากรแสตมป์ตามกฎหมาย',
                        value: 'ProxyFiles',
                        selected: false
                    },
                    {
                        name: 'เอกสารอื่นๆ',
                        value: 'OtherFiles',
                        selected: false
                    },
                ])
            }
        }
        // this.loading.submit = true;



    }

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth='lg'
        >
            <DialogContent>
                <div class="container">
                    <div class="row w-100">
                        <div class="col-sm-12 d-flex justify-content-between">
                            <label style={{
                                fontSize: '1.5rem',
                                fontWeight: '700',
                                color: '#3364af',
                                marginBottom: '10px'
                            }}>
                                เอกสารที่ต้องการขอเพิ่ม
                            </label>
                        </div>
                    </div>


                    <div class="row w-100">
                        <div class="col-sm-12 d-flex justify-content-between " >

                            <label style={{
                                fontSize: '19px',
                                fontWeight: '700'
                            }}>เอกสาร</label>

                            <FormControlLabel control={<Checkbox defaultChecked={false} onChange={e => {
                                const item = typeFiles?.map((v, index) => {
                                    v.selected = e.target.checked
                                    v.remark = e.target.checked !== true ? '' : v?.remark
                                    return v;

                                });
                                setTypeFiles([...item]);
                            }} />} label="เลือกทั้งหมด" />
                        </div>
                    </div>
                    <div class="row w-100" style={{ justifyContent: 'space-between' }}>
                        {typeFiles?.map((x, i) => (
                            <div class="col-md-6 col-sm-12 g-4" style={{
                                border: '1px solid #c1c1c1', marginLeft: '10px', width: '48%',
                                display: 'flex', flexDirection: 'column', padding: '10px'
                            }}>
                                <FormControlLabel control={<Checkbox checked={x?.selected} onChange={e => {
                                    const item = typeFiles?.map((v, index) => {
                                        v.selected = index === i ? e.target.checked : v?.selected;
                                        v.remark = index === i ? e.target.checked !== true ? '' : v?.remark : v?.remark;
                                        return v;

                                    });
                                    setTypeFiles([...item]);
                                }} />} label={x?.name} />
                                <TextField disabled={!x?.selected} placeholder='ระบุข้อความที่ต้องการ' onChange={e => {
                                    const item = typeFiles?.map((v, index) => {
                                        v.remark = index === i ? e.target.value : v?.remark;
                                        return v;

                                    });
                                    setTypeFiles([...item]);
                                }} value={x?.remark} />
                            </div>

                        ))}



                    </div>

                    <div class="col-md-12 mt-4 mb-4">
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <label style={{
                                fontSize: '19px',
                                fontWeight: '700'
                            }}>หมายเหตุ</label>
                            <TextField value={remark} onChange={e => setRemark(e.target.value)} variant="outlined" multiline rows={2} />
                        </div>
                    </div>
                    <div class="col-md-12 mt-4 mb-4">
                        <label style={{
                            fontSize: '19px',
                            fontWeight: '700'
                        }}>ช่องทางติดต่อเจ้าหน้าที่</label>
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div style={{ flexBasis: "49%" }}>

                                <TextField error={approverNameError} fullWidth placeholder='ระบุชื่อเจ้าหน้าที่' value={approverName} onChange={e => {
                                    setApproverNameError(false)
                                    setApproverName(e.target.value)
                                    }} variant="outlined" />

                            </div>
                            <div style={{ flexBasis: "49%" }}>

                                <TextField error={approverTelError} fullWidth placeholder='หมายเลขติดต่อ' value={approverTel} onChange={e => {
                                    setApproverTelError(false)
                                    setApproverTel(e.target.value)}} variant="outlined" />

                            </div>
                        </div>
                    </div>

                    <div class="row w-100">
                        <div class="col-12 " style={{ textAlign: "right" }}>
                            <Button onClick={() => handleAdd()} variant='contained' sx={{ width: "150px", marginRight: '20px' }}>ยืนยันการทำรายการ</Button>
                            <Button onClick={() => {
                                setOpen(false)
                                setApproverName('')
                                setApproverTel('')
                                setRemark('')
                                setApproverNameError(false)
                                setApproverTelError(false)
                                setTypeFiles([
                                    {
                                        name: 'สำเนาบัตรประจำตัวประชาชน',
                                        value: 'IdCardFiles',
                                        selected: false
                                    },
                                    {
                                        name: 'สำเนาหนังสือจดทะเบียนนิติบุคคล',
                                        value: 'JuristicPersonFiles',
                                        selected: false
                                    },
                                    {
                                        name: 'สำเนาใบอนุญาตขขายเมล็ดพันธุ์ควบคุม (พ.พ.4)',
                                        value: 'LicenseFiles',
                                        selected: false
                                    },
                                    {
                                        name: 'แผนผังแสดงที่อยู่สถานที่ตั้งของสถานที่จำหน่ายเมล็ดพันธุ์',
                                        value: 'StoreMapFiles',
                                        selected: false
                                    },
                                    {
                                        name: 'หนังสือมอบอำนาจซึ่งติดอากรแสตมป์ตามกฎหมาย',
                                        value: 'ProxyFiles',
                                        selected: false
                                    },
                                    {
                                        name: 'เอกสารอื่นๆ',
                                        value: 'OtherFiles',
                                        selected: false
                                    },
                                ])}} variant='outlined' sx={{ width: "150px", marginRight: '20px' }}>ยกเลิก</Button>
                        </div >

                    </div >
                </div >
            </DialogContent >
        </Dialog >
    )
}
